if (!customElements.get('image-with-text-gallery')) {
  class ImageWithTextGallery extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.init();

      if (window.Shopify && Shopify.designMode) {
        this.onBlockSelect = this.handleBlockSelect.bind(this);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      if (this.onBlockSelect) {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
      if (this.sliderInstance && this.sliderInstance.slider) {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = null;
      }
    }

    init() {
      if (!window.FoxTheme || !FoxTheme.Carousel || !FoxTheme.Swiper) return;
      if (this.sliderInstance) return;
      if (this.querySelectorAll('.swiper-slide').length < 2) return;

      const options = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        loopAdditionalSlides: 2,
        speed: 600,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        grabCursor: true,
        threshold: 2,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
      };

      const nextEl = this.querySelector('.swiper-button-next');
      const prevEl = this.querySelector('.swiper-button-prev');
      if (nextEl && prevEl) {
        options.navigation = { nextEl, prevEl };
      }

      const paginationEl = this.querySelector('.swiper-pagination');
      if (paginationEl) {
        options.pagination = {
          el: paginationEl,
          clickable: true,
        };
      }

      const modules = [FoxTheme.Swiper.EffectFade];
      const autoplayDelay = parseInt(this.dataset.autoplay, 10);
      const reduceMotion = FoxTheme.config && FoxTheme.config.motionReduced;
      if (autoplayDelay > 0 && !reduceMotion) {
        options.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
        modules.push(FoxTheme.Swiper.Autoplay);
      }

      this.sliderInstance = new window.FoxTheme.Carousel(this, options, modules);
      this.sliderInstance.init();
    }

    handleBlockSelect(event) {
      if (!this.sliderInstance || !this.sliderInstance.slider) return;
      if (event.detail.sectionId !== this.sectionId) return;

      const slide = event.target.closest('.swiper-slide');
      if (!slide || !this.contains(slide)) return;

      const index = Number(slide.dataset.index);
      if (Number.isNaN(index)) return;
      this.sliderInstance.slider.slideToLoop(index);
    }
  }

  customElements.define('image-with-text-gallery', ImageWithTextGallery);
}
